import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { beforeItems, afterItems } from '../data/content';
export function BeforeAfter() {
  return <section className="w-full bg-cream px-4 py-14 sm:px-6 sm:py-20" data-id="element-41" data-mp="3ogau3n1a2v3q">
      <div className="mx-auto max-w-5xl" data-id="element-42" data-mp="3oi41x5nmnldb">
        <h2 className="text-center font-display text-[26px] font-bold leading-tight text-ink sm:text-4xl" data-id="element-43" data-mp="3sglaltmp53wu">
          From guessing your way through every veneer…{' '}
          <span className="text-brand-600" data-id="element-44" data-mp="3jgoi1gx6rkwi">to knowing exactly what to look for.</span>
        </h2>

        <div className="mx-auto mt-7 max-w-xl rounded-2xl border border-brand-200 bg-white px-5 py-6 text-center" data-id="element-45" data-mp="34rsdhtuc8q0n">
          <p className="text-[14px] font-semibold text-brand-800/70" data-id="element-46" data-mp="39qby9qx73vrf">
            The difference starts when you stop asking:
          </p>
          <p className="mt-2 font-display text-xl font-bold text-[#B03636] line-through decoration-[#B03636]/40 sm:text-2xl" data-id="element-47" data-mp="2vrm34gtxs65p">
            “What should I do next?”
          </p>
          <p className="mt-5 text-[14px] font-semibold text-brand-800/70" data-id="element-48" data-mp="x3iqqqbet1mg">And start asking:</p>
          <p className="mt-2 font-display text-xl font-bold text-gogreen-600 sm:text-2xl" data-id="element-49" data-mp="t3qdw1ezg9ba">
            “What does this tooth actually need?”
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 lg:grid-cols-2" data-id="element-50" data-mp="123n7mhg8byd7">
          <div className="flex h-full flex-col rounded-3xl border border-[#E7CBCB] bg-[#FCF3F2] p-5 sm:p-6" data-id="element-51" data-mp="124gah7c2i3q2">
            <h3 className="flex items-center gap-2 text-[13px] font-extrabold uppercase tracking-[0.12em] text-[#B03636]" data-id="element-52" data-mp="ebpxqvwcbgeq">
              <span className="flex h-6 w-6 items-center justify-center rounded-full bg-[#B03636] text-white" data-id="element-53" data-mp="o3lykept9kmn">
                <XIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-54" data-mp="jcnhhcx00iic" />
              </span>
              Before
            </h3>
            <ul className="mt-5 space-y-3.5" data-id="element-55" data-mp="3rrnvj2zelqn2">
              {beforeItems.map(item => <li key={item} className="flex gap-3 text-[14.5px] leading-snug text-ink/85" data-id="element-56" data-mp="3msukribi4dql">
                  <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-[#B03636]" aria-hidden="true" data-id="element-57" data-mp="1qpof23nqgpkh" />
                  <span data-id="element-58" data-mp="1voslimj9w974">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="flex h-full flex-col rounded-3xl border border-[#BFE3CB] bg-[#F1FAF3] p-5 sm:p-6" data-id="element-59" data-mp="20hlrteue3plb">
            <h3 className="flex items-center gap-2 text-[13px] font-extrabold uppercase tracking-[0.12em] text-gogreen-700" data-id="element-60" data-mp="24gumqn161tig">
              <span className="flex h-6 w-6 items-center justify-center rounded-full bg-gogreen-500 text-white" data-id="element-61" data-mp="17tycae7z7p5j">
                <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-62" data-mp="1gsjozsqro9ye" />
              </span>
              With the Blueprint™
            </h3>
            <ul className="mt-5 space-y-3.5" data-id="element-63" data-mp="1lspk5iw8wel8">
              {afterItems.map(item => <li key={item} className="flex gap-3 text-[14.5px] leading-snug text-ink/85" data-id="element-64" data-mp="2s8i1y7p2fg4w">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gogreen-600" aria-hidden="true" data-id="element-65" data-mp="2x60fychxwljr" />
                  <span data-id="element-66" data-mp="37ckwzg1xonk5">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mx-auto mt-10 max-w-xl" data-id="element-67" data-mp="2xkow5x8gqjc8">
          <CTAButton label="I want a system for my veneer cases" note="One-time payment of $27 USD · Instant access" data-id="element-68" data-mp="2xjdsdxf0pbl4" />
        </div>
      </div>
    </section>;
}